import React from 'react'

import { Text } from 'govwell-ui'

import {
  ExternalSitePreview,
  InProductPreview,
} from 'src/pages/AIAssistantSettingsPage/IconPreviews'

const ServicesPortalPreview = () => (
  <div className="flex w-full flex-col overflow-hidden rounded-lg border border-neutral-200 shadow-sm">
    <div className="border-b border-neutral-200 bg-neutral-100 px-3 py-1.5">
      <Text.BodySmall className="font-medium text-neutral-500">Services Portal</Text.BodySmall>
    </div>
    <div className="relative flex h-56 flex-col bg-white">
      {/* Portal header */}
      <div className="flex items-center justify-between bg-neutral-900 px-3 py-1.5">
        <span className="text-[9px] font-semibold text-white">GovWell Portal</span>
        <div className="flex gap-1.5">
          <div className="h-1.5 w-6 rounded bg-white/50" />
          <div className="h-1.5 w-8 rounded bg-white/50" />
        </div>
      </div>
      {/* Hero with search and suggestions */}
      <div className="flex flex-col items-center bg-gradient-to-b from-neutral-50 to-white px-3 pt-3 pb-2">
        <span className="mb-1.5 text-[9px] font-semibold text-neutral-800">
          What can we help with?
        </span>
        {/* Search bar with AI button */}
        <div className="mb-1.5 flex w-full items-center gap-1 rounded border border-neutral-300 bg-white px-1.5 py-1">
          <span className="flex-1 text-[7px] text-neutral-500">Type here or select below...</span>
          <div className="rounded bg-orange-500 px-1.5 py-0.5">
            <span className="text-[6px] font-medium text-white">Ask AI</span>
          </div>
        </div>
        {/* Suggestion chips */}
        <div className="flex items-center gap-1.5">
          <span className="text-[7px] text-neutral-600">Help me find the right form</span>
          <span className="text-[7px] text-neutral-300">|</span>
          <span className="text-[7px] text-neutral-600">Ask about codes</span>
          <span className="text-[7px] text-neutral-300">|</span>
          <span className="text-[7px] text-neutral-600">Estimate fees</span>
        </div>
      </div>
      {/* Online Services section */}
      <div className="flex flex-1 flex-col px-3 pt-1">
        <span className="mb-1 text-[7px] font-semibold text-neutral-700">Online Services</span>
        <div className="flex gap-1.5">
          <div className="flex flex-1 flex-col rounded border border-neutral-200 bg-white p-1.5">
            <div className="mb-1 h-2 w-2 rounded bg-neutral-300" />
            <div className="mb-0.5 h-1.5 w-12 rounded bg-neutral-700" />
            <div className="h-1 w-full rounded bg-neutral-200" />
          </div>
          <div className="flex flex-1 flex-col rounded border border-neutral-200 bg-white p-1.5">
            <div className="mb-1 h-2 w-2 rounded bg-neutral-300" />
            <div className="mb-0.5 h-1.5 w-10 rounded bg-neutral-700" />
            <div className="h-1 w-full rounded bg-neutral-200" />
          </div>
        </div>
      </div>
      {/* Powered by GovWell */}
      <div className="flex justify-end px-3 py-1">
        <span className="text-[6px] text-neutral-500">Powered by GovWell</span>
      </div>
    </div>
  </div>
)

const SourcePreviews = () => {
  return (
    <div className="grid w-full grid-cols-1 gap-4 md:grid-cols-3">
      <ServicesPortalPreview />
      <ExternalSitePreview label="Website Widget" />
      <InProductPreview />
    </div>
  )
}

export default React.memo(SourcePreviews)
